import _orderBy from 'lodash/orderBy';

import type { Option } from 'shared/models/common';
import type { Option as FilterOption } from 'shared/components/TableFilterComponent';
import optionsAdapter from 'utils/optionsAdapter';

const sortOptions = <T extends string | number>(
  options: FilterOption<T>[],
  order: 'asc' | 'desc'
) => _orderBy(options, 'label', order);

type ProcessTableFilterOptionsSettings = {
  sortOrder: 'asc' | 'desc';
};

function processTableFilterOptions<T extends string | number>(
  options: Array<T | Option<T>>,
  settings?: ProcessTableFilterOptionsSettings
) {
  const sortOrder = settings?.sortOrder ?? 'asc';

  return sortOptions(optionsAdapter(options), sortOrder);
}

export default processTableFilterOptions;
